import React from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { CardLogBootstrapStyled } from "../../../../../styledComponents/CardBootstrapLog";
import LogButton from "../../../../../components/atoms/LogButton";
import { useHistory } from "react-router-dom";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 2rem 1rem;
`;

const Content = styled.div`
  width: 100%;
  max-width: 1080px;
`;

const InfoCard = styled(CardLogBootstrapStyled)`
  min-height: 140px;
`;

function ParentDashboard() {
  const user = useSelector((state) => state.authApp.user);
  const history = useHistory();

  return (
    <Wrapper>
      <Content>
        <Row className="mt-3">
          <Col>
            <h1 className="text-primary h3 font-weight-bold">
              Vista parent de dador
            </h1>
            <p className="text-muted mb-0">
              Accedes en modo solo lectura a las cuentas dador asociadas al CUIT{" "}
              <strong>{user?.cuit || "-"}</strong>.
            </p>
          </Col>
        </Row>

        <Row className="mt-4">
          <Col md="6">
            <InfoCard className="shadow-6dp p-4 mb-4">
              <h2 className="h5 font-weight-bold text-primary">
                Cuentas agrupadas
              </h2>
              <p className="mb-0 text-muted">
                Desde este usuario podes consultar informacion consolidada de
                facturacion y actividad de los dadores que comparten CUIT.
              </p>
            </InfoCard>
          </Col>
          <Col md="6">
            <InfoCard className="shadow-6dp p-4 mb-4">
              <h2 className="h5 font-weight-bold text-primary">
                Modo restringido
              </h2>
              <p className="mb-0 text-muted">
                Esta cuenta no puede crear viajes ni operar como un dador comun.
                Su uso esta limitado a consultas y seguimiento.
              </p>
            </InfoCard>
          </Col>
        </Row>

        <Row>
          <Col md="12">
            <InfoCard className="shadow-6dp p-4 mb-4">
              <Row className="align-items-center">
                <Col md="8">
                  <h2 className="h5 font-weight-bold text-primary">
                    Facturacion agrupada
                  </h2>
                  <p className="mb-0 text-muted">
                    Consulta las cuentas y facturas de todos los dadores activos
                    que comparten este CUIT, sin mezclarte con la operatoria
                    diaria de cada cuenta.
                  </p>
                </Col>
                <Col md="4" className="mt-3 mt-md-0">
                  <LogButton
                    title="Ver cuentas agrupadas"
                    color="primary"
                    border="curve"
                    block
                    onClick={() => history.push("/app/billing-parent-dador")}
                  />
                </Col>
              </Row>
            </InfoCard>
          </Col>
        </Row>
      </Content>
    </Wrapper>
  );
}

export default ParentDashboard;
